import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

import { getXCLEARCorrelationInfo } from '@api/utils'
import { session } from './session'
import { createAuthPipe } from './createAuthPipe'
import { detectFlow } from './utils'
import { getVariant, useAuthExperiment } from './useAuthExperiement'

export function useAuthPipe() {
  const router = useRouter()
  const experiment = useAuthExperiment()
  const pipeRef = useRef<ReturnType<typeof createAuthPipe> | undefined>(
    undefined
  )
  const routeRef = useRef<string>('')
  const route = router.route

  if (!pipeRef.current || routeRef.current !== route) {
    routeRef.current = route
    const flow = detectFlow(
      route,
      router.query?.desiredPath as string | undefined
    )

    const [, enabled] = experiment.enabled
    const experimentEnabled =
      enabled?.status === 'ready' ? `${enabled.value}` : enabled.status
    const { value: experimentVariant, uid: experimentUID } = getVariant(
      route,
      experiment.pages
    )

    pipeRef.current = createAuthPipe({
      xCLEARCorrelationInfo: getXCLEARCorrelationInfo(),
      authFlowSessionId: session.authFlowSessionId,
      flow,
      route,
      experimentEnabled,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      experimentVariant: experimentVariant!,
      experimentUID,
    })
  }

  useEffect(() => {
    return () => {
      pipeRef.current = undefined
    }
  }, [])

  return pipeRef.current
}
